import { Form } from "antd";
import { useGlobalFilterContext } from "contexts/GlobalFilterContext";
import { isNil } from "lodash";
import React, { forwardRef, useEffect } from "react";
import { GithubSecretScanSupportAPI } from "restAPI/ToolsIntegrationAPI";
import { FieldTypes, generateFormFields } from "utils/formUtils";

const GithubSecretScanRealtimeIngestionSelection = forwardRef(({toolName},ref) => {
    const { globalFilterHash } = useGlobalFilterContext();
    const [form] = Form.useForm();

    useEffect(() => {
      const { cancel, promise } = GithubSecretScanSupportAPI.getGithubSecretScanToolConfig();
      promise.then((resData) => {
        const existingValue = resData?.config?.realtimeIngestionToggle;
        if (!isNil(existingValue)) {
          form.setFieldsValue({
            realtimeIngestionToggle: existingValue,
          });
        } else {
          form.setFieldsValue({
            realtimeIngestionToggle: false,
          });
        }
      });
      return cancel;
    }, [globalFilterHash, form]);

    const fields = [
      {
        name: "realtimeIngestionToggle",
        type: FieldTypes.BOOLEAN,
        label: "Enable Real-Time Alert Ingestion",
        help: "ArmorCode will monitor your GitHub repos via webhooks and automatically sync any new secret findings as they happen",
        inline: true,
      },
    ];

    return (
        <Form
        form={form}
        ref={ref}
        style={{ minWidth: 400 }}
        layout="horizontal"
        initialValues={{ realtimeIngestionToggle: false }}
        >
          {generateFormFields(fields)}
        </Form>
    );
  },
);

export default GithubSecretScanRealtimeIngestionSelection;
